import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import {
  Box,
  CircularProgress,
  Divider,
  Popover,
  Stack,
  Typography
} from '@mui/material'
import * as React from 'react'

import { useAuth } from 'components/AuthProvider'
import Button from 'components/Button'
import { Vault } from 'api/inventory'
import { generateUsername } from 'utils/util'
import useVault from 'hooks/useVault/useVault'
import useStyles from './styles'

interface SwitchVaultProps {
  text?: string
  handleActive?: (id: number | null) => Promise<Vault | null>
  showCreateButton?: boolean
  loading?: boolean
  spotPrice?: string
}

export default function ButtonMyVault(props: SwitchVaultProps) {
  const { handleActive, loading = false } = props

  const { classes } = useStyles()
  const { user } = useAuth()

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const { activatedVault, handleActiveVault } = useVault()

  const vaultList = React.useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return user?.vaults?.filter((vault: any) => {
      if (!activatedVault.id && !vault.name) {
        return false
      }
      return vault.id !== activatedVault.id
    })
  }, [user?.vaults, activatedVault])

  const togglePopover = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      if (vaultList?.length) {
        setAnchorEl(prev => (prev ? null : event.currentTarget || null))
      }
    },
    [vaultList?.length]
  )

  return (
    <>
      <Button
        aria-describedby='my-vault-popover'
        variant='text'
        onClick={togglePopover}
        className={classes.buttonMyVault}
        fullWidth
      >
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          {/*
          <Avatar>
            {nameToInitials(
              activatedVault.name ??
                user?.profile?.firstName + ' ' + user?.profile?.lastName
            )}
          </Avatar>
          */}
          <Typography
            variant='h6'
            color='primary.dark'
            whiteSpace='nowrap'
            overflow='hidden'
            textOverflow='ellipsis'
            textAlign='center'
          >
            {activatedVault.name}'s vault
          </Typography>
          {Boolean(vaultList?.length) && (
            <KeyboardArrowDown className={classes.buttonMyVaultIconDown} />
          )}
        </Box>
      </Button>
      <Popover
        id='my-vault-popover'
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={togglePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        className={classes.popover}
      >
        <Stack padding={2} textAlign='center' position='relative' gap={2}>
          {loading ? (
            <Stack
              position='absolute'
              justifyContent='center'
              alignItems='center'
              width='100%'
              bgcolor='transparent'
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0
              }}
              zIndex={1}
            >
              <CircularProgress color='default' />
            </Stack>
          ) : null}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {vaultList?.map((vault: any, index: number) => {
            return (
              <React.Fragment key={vault.id}>
                <Typography
                  color='primary.main'
                  onClick={() => {
                    handleActiveVault(Number(vault.id))
                      .then(() => {
                        handleActive && handleActive(Number(vault.id))
                      })
                      .finally(() => setAnchorEl(null))
                  }}
                  sx={{ cursor: 'pointer' }}
                >
                  {vault.name || generateUsername(user)}'s VAULT
                </Typography>
                {index === vaultList.length - 1 ? null : (
                  <Divider className={classes.divider} />
                )}
              </React.Fragment>
            )
          })}
        </Stack>
      </Popover>
    </>
  )
}
